import { render, staticRenderFns } from "./menu_left.vue?vue&type=template&id=2ef3b1a4&lang=pug&"
import script from "./menu_left.vue?vue&type=script&lang=coffee&"
export * from "./menu_left.vue?vue&type=script&lang=coffee&"
import style0 from "./menu_left.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports